import styled from 'styled-components';

// ── Patient header ────────────────────────────────────────────────────────────

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 10px;
  border-bottom: 1.5px solid #cccccc;
  margin-bottom: 12px;
`;

export const HeaderLeft = styled.div`
  flex: 1;
  min-width: 0;
  padding-right: 16px;
`;

export const PatientName = styled.h1`
  font-size: 24px;
  font-weight: 800;
  margin: 0 0 4px 0;
  color: #111;
  letter-spacing: -0.4px;
  line-height: 1.1;
  overflow-wrap: anywhere;
  word-break: break-word;
`;

export const PatientMeta = styled.p`
  font-size: 10px;
  color: #555;
  margin: 0 0 2px 0;
  line-height: 1.4;
  overflow-wrap: anywhere;
  word-break: break-word;
`;

export const HeaderRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  min-width: 72px;
`;

export const AvatarCircle = styled.div`
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: #d6e8ff;
  color: #2a5ab0;
  font-size: 15px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const GeneratedLabel = styled.div`
  font-size: 8.5px;
  color: #999;
  text-align: center;
  line-height: 1.35;
`;

// ── Medical vitals cards ──────────────────────────────────────────────────────

export const MedicalCardsRow = styled.div`
  display: flex;
  border: 1px solid #e2e2e2;
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 10px;
`;

export const MedicalCard = styled.div`
  flex: 1;
  min-width: 0;
  text-align: center;
  padding: 10px 6px 8px;
  border-right: 1px solid #e2e2e2;

  &:last-child {
    border-right: none;
  }
`;

export const MedicalCardValue = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #111;
  margin-bottom: 2px;
  line-height: 1.1;
  overflow-wrap: anywhere;
  word-break: break-word;
`;

export const MedicalCardLabel = styled.div`
  font-size: 8.5px;
  color: #999;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

// ── Subsections within a medical card ────────────────────────────────────────

export const Subsection = styled.div`
  margin-top: 9px;
  padding-top: 9px;
  border-top: 1px solid #f0f0f0;
`;

export const SubsectionLabel = styled.div`
  font-size: 7.5px;
  font-weight: 700;
  letter-spacing: 1px;
  color: #aaa;
  text-transform: uppercase;
  margin-bottom: 5px;
`;

// ── Insurance ─────────────────────────────────────────────────────────────────

export const InsuranceHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: #aaa;
  text-transform: uppercase;
  padding-bottom: 4px;
  border-bottom: 1px solid #e8e8e8;
  margin-bottom: 4px;
`;

export const InsuranceRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 8px;
  padding: 3px 0;
  border-bottom: 1px solid #f5f5f5;

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
`;

export const InsuranceProvider = styled.div`
  font-size: 10.5px;
  font-weight: 700;
  color: #111;
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
`;

export const InsurancePlanNum = styled.div`
  font-size: 10.5px;
  color: #333;
  flex: 0 1 45%;
  min-width: 0;
  text-align: right;
  overflow-wrap: anywhere;
  word-break: break-word;
`;

// ── Directives ────────────────────────────────────────────────────────────────

export const DirectiveItem = styled.div`
  margin-bottom: 7px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const DirectiveLabel = styled.div`
  font-size: 7.5px;
  font-weight: 700;
  letter-spacing: 0.7px;
  color: #aaa;
  text-transform: uppercase;
  margin-bottom: 2px;
`;

export const DirectiveValue = styled.div`
  font-size: 10.5px;
  font-weight: 600;
  color: #111;
  border-left: 2.5px solid #2a5ab0;
  padding-left: 6px;
  line-height: 1.4;
  overflow-wrap: anywhere;
  word-break: break-word;
`;

// ── Footer ────────────────────────────────────────────────────────────────────

export const PageFooter = styled.div`
  margin-top: 12px;
  padding-top: 7px;
  border-top: 1px solid #e2e2e2;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 8px;
  color: #bbb;
`;
